<div class="delivery-all-mentors-view-part">
	<all-mentors-grid-part parent='delivery' [service]="pageService" [rows]="allMentors()"></all-mentors-grid-part>
</div>